export const ESITI = ["APPROVA", "RESO", "ANNULLATO"];

export function selectTradetrackerRows(rows, selection) {
  const search = selection.ricerca.trim().toLowerCase();
  return rows.filter(row => {
    const matchesEsito = selection.esito === "TUTTI" ||
      (selection.esito === "DA_VALUTARE" ? row.esito == null : row.esito === selection.esito);
    return matchesEsito && (!search || [row.idOrdinePs, row.idTransazioneTt]
      .some(value => String(value || "").toLowerCase().includes(search)));
  });
}

export function composePrestashopClipboard(rows, selection) {
  if (!ESITI.includes(selection.esito)) return { text: "", count: 0 };
  const ids = [...new Set(selectTradetrackerRows(rows, selection)
    .map(row => String(row.idOrdinePs ?? "").trim()).filter(Boolean))];
  return { text: ids.join("\r\n"), count: ids.length };
}

export async function copyToClipboard(text) {
  if (navigator.clipboard?.writeText) {
    try { await navigator.clipboard.writeText(text); return; } catch (_) { /* Prova il fallback locale. */ }
  }
  const previousFocus = document.activeElement;
  const area = document.createElement("textarea");
  area.value = text;
  area.setAttribute("readonly", "");
  area.style.position = "fixed";
  area.style.opacity = "0";
  document.body.appendChild(area);
  try {
    area.select();
    if (!document.execCommand("copy")) throw new Error("Copia non riuscita: selezionare e copiare gli id manualmente");
  } finally {
    area.remove();
    previousFocus?.focus();
  }
}
